<template>
  <div class='lt-scene-personal'>
    <SceneItemTransition transition='slideY-down' :isActive="personal > 0">
      <img
        src="../../assets/bag1.svg"
        class='lt-scene-personal-bag-1'
        alt=""
      />
    </SceneItemTransition>

    <SceneItemTransition transition='slideY-down' :isActive="personal > 2">
      <img
        src="../../assets/bag3.svg"
        class='lt-scene-personal-bag-3'
        alt=""
      />
    </SceneItemTransition>

    <SceneItemTransition transition='slideY-down' :isActive="personal > 1">
      <img
        src="../../assets/bag2.svg"
        class='lt-scene-personal-bag-2'
        alt=""
      />
    </SceneItemTransition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import SceneItemTransition from '../../components/SceneItemTransition';

export default {
  components: {
    SceneItemTransition,
  },
  computed: {
    ...mapFields([
      'scene.status.personal',
    ]),
  },
};
</script>

<style lang='scss'>
$width: 228;
$height: 141;

.lt-scene-personal {
  position: absolute;
  top: 60.75%;
  left: 3.75%;
  width: 11.43%;
  height: 16.75%;
}

.lt-scene-personal-bag-1 {
  position: absolute;
  top: -10px;
  top: proportionSize(31, $height);
  left: proportionSize(4, $width);
  width: proportionSize(84, $width);
}

.lt-scene-personal-bag-2 {
  position: absolute;
  top: proportionSize(50, $height);
  left: proportionSize(33, $width);
  width: proportionSize(139, $width);
}

.lt-scene-personal-bag-3 {
  position: absolute;
  top: proportionSize(6, $height);
  left: proportionSize(115, $width);
  width: proportionSize(113, $width);
}
</style>
